export default class FreeLog {
  /**
   * @param {string} name - freelog name
   * @param {object} obj - log values
   */
  constructor(name = '', obj = {}) {
    this.name = name;
    this.obj = obj;
    this.init();
  }

  init() {
    this.onFreeLog();
  }

  onFreeLog() {
    if(this.name.length) {
      SL.freelog.send({[this.name]: this.obj});
    }
  }
}
